/**
 * @file Timeline view
 */


    // var zrUtil = require('zrender/lib/core/util');
    // var graphic = require('../../util/graphic');
    var ComponentView = require('../../view/Component');

    module.exports = ComponentView.extend({

        type: 'timeline'
    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/timeline/TimelineView.js
// module id = 474
// module chunks = 1